import { render, staticRenderFns } from "./FavLocationCard.vue?vue&type=template&id=94a4f85e"
import script from "./FavLocationCard.vue?vue&type=script&lang=ts"
export * from "./FavLocationCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports